import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// UI

import DownloadButton from '@/components/Elements/Button/DownloadButton'
import ViewFileButton from '@/components/Elements/Button/ViewFileButton'
import {
  Box,
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
// Custom

import { setFileHistoryModal } from '@/stores/ui/uiSlice'

import EditableTable from '@/components/Table/EditableTable'
import { createColumnHelper } from '@tanstack/react-table'

const FileHistoryModal = () => {
  // Redux

  const { show, title, files } = useSelector((state) => state.ui.fileHistoryModal)

  // Local
  const [data, setData] = useState([])

  // Hooks
  const dispatch = useDispatch()
  const columnHelper = createColumnHelper()

  const columnDef = useMemo(
    () => [
      columnHelper.accessor('createdAt', {
        header: () => <span>Upload Date</span>,
      }),

      columnHelper.accessor('createdBy', {
        header: () => <span>Upload By</span>,
      }),

      columnHelper.accessor('originalFileName', {
        header: () => <span>File Name</span>,
      }),

      columnHelper.accessor('fileId', {
        header: () => <span></span>,
        cell: ({ getValue, row: { original } }) => {
          const fileName = original?.originalFileName || ''

          return (
            <HStack>
              <ViewFileButton fileId={getValue()} isHide={!fileName.toLowerCase().includes('.pdf')} />
              <DownloadButton fileId={getValue()} fileName={fileName} />
            </HStack>
          )
        },
      }),
    ],
    []
  )

  const transformFilesData = (documents) => {
    if (!Array.isArray(documents)) {
      return []
    }
    return documents.map((doc) => ({
      version: doc.version,
      createdAt: moment(doc.createdAt).format('DD-MMM-YYYY'),
      createdBy: doc.createdBy?.fullName || '',
      fileId: doc._id,
      originalFileName: doc.originalFileName,
    }))
  }

  useEffect(() => {
    if (show) {
      setData(transformFilesData(files))
    }
  }, [show, files])

  // Handler

  const closeModal = () => {
    dispatch(
      setFileHistoryModal({
        show: false,
        files: [],
      })
    )
  }

  const onSubmit = (e) => {
    e.preventDefault()
  }

  return (
    <Modal isOpen={show} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW="1000px">
        <form onSubmit={onSubmit}>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box w="100%">
              <EditableTable columnDef={columnDef} data={show ? data : []} disabled={true} tableWidth="100%" />
            </Box>
          </ModalBody>

          <ModalFooter>
            <Flex w="100%">
              <Button colorScheme="gray" onClick={closeModal}>
                Close
              </Button>
            </Flex>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  )
}

export default FileHistoryModal
